export const isVisibleQuote = quote => {
  if (quote.status !== 'FAILED') return true
  return !/(?:暂无可用运费|产品未启用)/.test(String(quote.failureReason || ''))
}
